import * as React from "react"
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router-dom"
import driverinfosecurity from "../../utils/DriverInfoSecurity";

type RouteComponent = React.FC<RouteComponentProps<{}>> | React.ComponentClass<any>

//const deleted = driverinfosecurity.logout();   //To delete token

const AUTHENTICATED: boolean = driverinfosecurity.hasValidToken();
const ISADMIN: boolean = driverinfosecurity.isAdmin();

export const AdminRoute: React.FC<RouteProps> = ({ component, ...rest }) => {
    const renderFn = (Component?: RouteComponent) => (props: RouteComponentProps<{}>) => {
        if (!Component) {
            return null
        }

  

        if (driverinfosecurity.hasValidToken() && driverinfosecurity.isAdmin()) {
            //console.log("Route evaluation is authenticated " + AUTHENTICATED);
            return <Component {...props as any} />
        }
        else {
        }

        const redirectProps = {
            to: {
                pathname: "/login",
                state: { from: props.location },
            },
        }

        

       // console.log("Route evaluation is authenticated " + AUTHENTICATED);

        return <Redirect {...redirectProps} />
    }

    //console.log("rendercomponent");
    return <Route {...rest} render={renderFn(component as RouteComponent)} />
}